var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.content),expression:"content"}],attrs:{"icon":['far', 'info-circle'],"transform":"shrink-1"}})}
var staticRenderFns = []

export { render, staticRenderFns }